import React from "react";
import GlobalFilter from "../../Utility/GlobalFilter/GlobalFilter";
import {
  getClientNamesFromList,
  getClientNamesFromProjectsList,
  mapProjectsToFilterOptions,
} from "./projectMappers";

export default function ProjectFilter({
  listingFilter,
  handleFilterChange,
  handleFilterReset,
  applyFilters,
  projectsData,
  /** Full project list from GET all-projects API — populates Project Name dropdown with every project */
  allProjectsData = null,
  clientsData,
}) {
  // Dynamic handler for all filters
  const handleFilter = (name) => (e) => {
    handleFilterChange({
      target: {
        name: name,
        value: e.target.value,
      },
    });
  };

  const clientNamesFromClients = getClientNamesFromList(clientsData ?? null);
  const clientNamesFromProjects = getClientNamesFromProjectsList(projectsData ?? null);
  const clientNames =
    clientNamesFromClients.length > 0 ? clientNamesFromClients : clientNamesFromProjects;

  const projectOptions = mapProjectsToFilterOptions(allProjectsData ?? projectsData ?? null, {
    valueMode: "name",
  });

  const fields = [
    {
      type: "dropdown",
      name: "clientName",
      label: "Client Name",
      options: clientNames,
      placeholder: "Select Client Name",
      searchable: true,
      onChange: handleFilter("clientName"),
      zIndex: true,
    },
    {
      type: "dropdown",
      name: "projectName",
      label: "Project Name",
      options: projectOptions,
      placeholder: "Select Project Name",
      searchable: true,
      onChange: handleFilter("projectName"),
      zIndex: true,
    },
    {
      type: "dropdown",
      name: "status",
      label: "Status",
      options: ["All", "Active", "Completed", "On Hold", "Archived"],
      placeholder: "Select Status",
      onChange: handleFilter("status"),
    },
  ];

  return (
    <GlobalFilter
      listingFilter={listingFilter}
      handleFilterChange={handleFilterChange}
      handleFilterReset={handleFilterReset}
      applyFilters={applyFilters}
      fields={fields}
      // columns={2}
      buttonWidth="w-full md:w-auto"
      flexClassName="flex flex-wrap md:flex-nowrap gap-2 items-end"
    />
  );
}
